






























import { Component, Prop } from 'vue-property-decorator';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import { RateSourceModule } from '@/store/Products/RateSourceModule';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import { RegionsModule } from '@/store/Settings/RegionsModule';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueFieldGroup';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import CompareDialog from '@/components/Shared/CompareDialog.vue';
import EntityType from '@/models/Shared/EntityType';

@Component({ name: 'History', components: { FieldLabel, CompareDialog } })
export default class extends SaascadaVueFieldGroup {

    @Prop({required: true})
    entityType: EntityType;

    async beforeMount() {
        // Note this means history will only be loaded once on page
        // load rather than every time you click the history tab
        switch (this.entityType) {
            case EntityType.Product: {
                await ProductDetailsModule.getHistory();
                break;
            }
            case EntityType.ProductIssue: {
                await ProductIssueDetailsModule.getHistory();
                break;
            }
            case EntityType.RateSource: {
                await RateSourceModule.getHistory();
                break;
            }
            case EntityType.DepositAccount: {
                await DepositAccountModule.getHistory();
                break;
            }
            case EntityType.LendingAccount: {
                await LendingAccountModule.getHistory();
                break;
            }
            case EntityType.Region: {
                await RegionsModule.getHistory();
                break;
            }
        }
    }

    get loading() {
        switch (this.entityType) {
            case EntityType.Product: {
                return ProductDetailsModule.loadingHistory;
            }
            case EntityType.ProductIssue: {
                return ProductIssueDetailsModule.loadingHistory;
            }
            case EntityType.RateSource: {
                return RateSourceModule.loadingHistory;
            }
            case EntityType.DepositAccount: {
                return DepositAccountModule.loadingHistory;
            }
            case EntityType.LendingAccount: {
                return LendingAccountModule.loadingHistory;
            }
            case EntityType.Region: {
                return RegionsModule.loadingHistory;
            }
        }
    }

    get history() {
        switch (this.entityType) {
            case EntityType.Product: {
                return ProductDetailsModule.history;
            }
            case EntityType.ProductIssue: {
                return ProductIssueDetailsModule.history;
            }
            case EntityType.RateSource: {
                return RateSourceModule.history;
            }
            case EntityType.DepositAccount: {
                return DepositAccountModule.history;
            }
            case EntityType.LendingAccount: {
                return LendingAccountModule.history;
            }
            case EntityType.Region: {
                return RegionsModule.history;
            }
        }
    }

}
